const termsTranslations = {
  en: {
    back: "← Back to Home",
    eyebrow: "LEGAL",
    title: "Terms of Use",
    effectiveDate: "Effective Date: September 5, 2026",
    translationNotice: null,

    intro:
      "Welcome to ACE Massage Hub and the Massage Exam Practice App. By accessing or using this website, application, learning platform, practice tools, subscription services, or related features, you agree to these Terms of Use.",

    sections: [
      {
        title: "1. Educational Purpose",
        paragraphs: [
          "ACE Massage Hub provides educational materials, practice questions, study tools, vocabulary resources, AI-generated explanations, and other learning features intended to support massage therapy education and exam preparation.",
          "Our services are for educational purposes only. We do not guarantee that use of the platform will result in passing the MBLEx, obtaining a massage therapy license, renewing a professional license, or meeting any particular state licensing requirement.",
        ],
      },
      {
        title: "2. Account Registration",
        paragraphs: [
          "Certain features require an account. You are responsible for providing accurate information, protecting your login credentials, and maintaining the security of your account.",
          "You may not share your account, allow unauthorized users to access paid content through your account, or create multiple accounts to avoid usage limits, subscription requirements, or other platform restrictions.",
        ],
      },
      {
        title: "3. Free and Premium Access",
        paragraphs: [
          "Free accounts may receive access to a limited number of practice questions and selected platform features. Premium subscribers may receive expanded access, including the full eligible question bank, Learning Center, Vocabulary, unlimited AI explanations, and other Premium features made available from time to time.",
        ],
      },
      {
        title: "4. Subscription Billing",
        paragraphs: [
          "Premium subscriptions may be offered on a monthly or quarterly basis. Current pricing is displayed before checkout.",
          "Unless canceled, paid subscriptions automatically renew at the applicable billing interval using the payment method associated with your account.",
          "You may cancel your subscription through the available billing management tools. If you cancel, Premium access generally continues until the end of the current paid billing period unless otherwise stated.",
        ],
      },
      {
        title: "5. Free Trials",
        paragraphs: [
          "Eligible new subscribers may be offered a three-day Premium trial. Eligibility may be limited to one trial per user, payment method, account, household, or other reasonable fraud-prevention criteria.",
          "If a trial requires a payment method and is not canceled before the trial ends, the subscription may automatically convert to a paid subscription at the selected plan price.",
        ],
      },
      {
        title: "6. Refunds",
        paragraphs: [
          "Subscription payments are generally non-refundable once charged, except where required by law or where ACE Massage Hub determines that a refund is appropriate.",
          "If you believe you were charged incorrectly, contact us at supports@acemassagehub.com.",
        ],
      },
      {
        title: "7. AI-Generated Explanations",
        paragraphs: [
          "Some educational explanations may be generated or assisted by artificial intelligence. AI-generated content may contain errors, omissions, or incomplete information and should not be treated as authoritative medical, legal, licensing, or professional advice.",
          "Students should use AI explanations as a study aid together with approved educational materials, instructor guidance, and official licensing resources.",
        ],
      },
      {
        title: "8. Continuing Education Courses",
        paragraphs: [
          "Continuing education courses may be added to the platform in the future.",
          "Acceptance of continuing education hours varies by state, licensing board, profession, course type, provider approval, and other requirements. Users are responsible for confirming whether a course is accepted by the applicable licensing authority before relying on it for license renewal.",
        ],
      },
      {
        title: "9. Intellectual Property",
        paragraphs: [
          "Platform content, including practice questions, explanations, course materials, graphics, software, study resources, and other educational materials, is owned by or licensed to ACE Massage Hub and is protected by applicable intellectual property laws.",
          "You may use the content for your personal, non-commercial educational use. You may not copy, scrape, download in bulk, reproduce, resell, publish, distribute, create competing question banks from, or otherwise commercially exploit platform content without written permission.",
        ],
      },
      {
        title: "10. Prohibited Conduct",
        paragraphs: [
          "You agree not to misuse the platform, attempt to gain unauthorized access, interfere with platform security, automate extraction of content, bypass subscription or usage controls, reverse engineer protected systems, or use the service for unlawful purposes.",
        ],
      },
      {
        title: "11. Availability and Changes",
        paragraphs: [
          "We may update, modify, suspend, remove, or replace features, content, pricing, question banks, AI models, or other parts of the service as the platform evolves.",
          "We do not guarantee uninterrupted or error-free access to the service.",
        ],
      },
      {
        title: "12. Disclaimer of Warranties",
        paragraphs: [
          'The service is provided on an "as is" and "as available" basis to the maximum extent permitted by law. ACE Massage Hub makes no guarantee regarding exam results, licensing outcomes, employment outcomes, educational results, or the accuracy of every piece of platform content.',
        ],
      },
      {
        title: "13. Limitation of Liability",
        paragraphs: [
          "To the maximum extent permitted by law, ACE Massage Hub will not be liable for indirect, incidental, special, consequential, or punitive damages arising from use of or inability to use the service.",
        ],
      },
      {
        title: "14. Termination",
        paragraphs: [
          "We may suspend or terminate accounts that violate these Terms, misuse the platform, engage in fraud, threaten platform security, or improperly access or distribute protected content.",
        ],
      },
      {
        title: "15. Changes to These Terms",
        paragraphs: [
          "We may update these Terms from time to time. Continued use of the service after updated Terms become effective constitutes acceptance of the revised Terms.",
        ],
      },
      {
        title: "16. Contact",
        paragraphs: [
          "Questions regarding these Terms may be sent to:",
        ],
      },
    ],

    contactEmail: "supports@acemassagehub.com",
  },

  zh: {
    back: "← 返回首页",
    eyebrow: "法律条款",
    title: "使用条款",
    effectiveDate: "生效日期：2026年9月5日",
    translationNotice:
      "本中文译文仅为方便阅读而提供。如本译文与英文版本存在任何不一致，以英文版本为准。",

    intro:
      "欢迎使用 ACE Massage Hub 和 Massage Exam Practice App。访问或使用本网站、应用程序、学习平台、练习工具、订阅服务或相关功能，即表示您同意遵守本使用条款。",

    sections: [
      {
        title: "1. 教育用途",
        paragraphs: [
          "ACE Massage Hub 提供教育资料、练习题、学习工具、词汇资源、AI 生成的解析以及其他学习功能，旨在帮助用户学习按摩治疗相关知识并准备考试。",
          "我们的服务仅用于教育目的。我们不保证使用本平台一定能够通过 MBLEx、取得按摩治疗师执照、完成专业执照续期，或满足任何特定州的执照要求。",
        ],
      },
      {
        title: "2. 账户注册",
        paragraphs: [
          "部分功能需要注册账户。您有责任提供准确的信息、妥善保护登录凭据，并维护账户安全。",
          "您不得共享账户、允许未经授权的用户通过您的账户访问付费内容，也不得通过创建多个账户来规避使用限制、订阅要求或平台的其他限制。",
        ],
      },
      {
        title: "3. 免费及 Premium 权限",
        paragraphs: [
          "免费账户可能只能访问有限数量的练习题和部分平台功能。Premium 订阅用户可能获得更多功能，包括符合条件的完整题库、Learning Center、Vocabulary、无限 AI 解析以及平台不时提供的其他 Premium 功能。",
        ],
      },
      {
        title: "4. 订阅与收费",
        paragraphs: [
          "Premium 订阅可能按月或按季度提供。当前价格将在结账前显示。",
          "除非用户取消，否则付费订阅将按照适用的计费周期，使用与账户关联的付款方式自动续订。",
          "您可以通过平台提供的账单管理工具取消订阅。取消后，除非另有说明，Premium 权限通常会持续到当前已付款计费周期结束。",
        ],
      },
      {
        title: "5. 免费试用",
        paragraphs: [
          "符合条件的新订阅用户可能获得三天 Premium 免费试用。为防止滥用或欺诈，试用资格可能限制为每位用户、付款方式、账户、家庭或其他合理标准仅享受一次。",
          "如果免费试用需要提供付款方式，并且您没有在试用结束前取消，则订阅可能会按照所选套餐的价格自动转为付费订阅。",
        ],
      },
      {
        title: "6. 退款",
        paragraphs: [
          "订阅费用一旦收取通常不予退款，但法律另有要求或 ACE Massage Hub 认为适合退款的情况除外。",
          "如果您认为账户被错误收费，请联系 supports@acemassagehub.com。",
        ],
      },
      {
        title: "7. AI 生成的解析",
        paragraphs: [
          "部分教育解析可能由人工智能生成或辅助生成。AI 生成的内容可能存在错误、遗漏或信息不完整的情况，不应被视为权威的医疗、法律、执照申请或专业建议。",
          "学生应将 AI 解析作为辅助学习工具，并结合经认可的教育资料、教师指导以及官方执照机构提供的资源进行学习。",
        ],
      },
      {
        title: "8. 继续教育课程",
        paragraphs: [
          "平台未来可能会增加继续教育课程。",
          "继续教育学时是否被接受取决于所在州、执照委员会、专业类别、课程类型、课程提供方资格以及其他要求。用户在将课程用于执照续期之前，有责任自行确认相关课程是否被适用的执照管理机构认可。",
        ],
      },
      {
        title: "9. 知识产权",
        paragraphs: [
          "平台内容，包括练习题、解析、课程资料、图形、软件、学习资源及其他教育材料，均由 ACE Massage Hub 所有或经合法授权使用，并受到适用的知识产权法律保护。",
          "您可以将这些内容用于个人、非商业性的教育用途。未经书面许可，您不得复制、抓取、大量下载、再制作、转售、发布、分发、利用平台内容建立竞争性题库，或以其他方式对平台内容进行商业利用。",
        ],
      },
      {
        title: "10. 禁止行为",
        paragraphs: [
          "您同意不得滥用本平台、尝试未经授权访问系统、干扰平台安全、自动化提取内容、绕过订阅或使用限制、对受保护系统进行逆向工程，或将本服务用于任何违法目的。",
        ],
      },
      {
        title: "11. 服务可用性及变更",
        paragraphs: [
          "随着平台的发展，我们可能更新、修改、暂停、删除或替换功能、内容、价格、题库、AI 模型或服务的其他部分。",
          "我们不保证本服务始终不中断或完全不存在错误。",
        ],
      },
      {
        title: "12. 保证免责声明",
        paragraphs: [
          "在法律允许的最大范围内，本服务按照“现状”和“可用状态”提供。ACE Massage Hub 不对考试结果、执照申请结果、就业结果、学习成果或平台所有内容的绝对准确性作出保证。",
        ],
      },
      {
        title: "13. 责任限制",
        paragraphs: [
          "在法律允许的最大范围内，对于因使用或无法使用本服务而产生的任何间接、附带、特殊、后果性或惩罚性损害，ACE Massage Hub 不承担责任。",
        ],
      },
      {
        title: "14. 账户终止",
        paragraphs: [
          "对于违反本条款、滥用平台、实施欺诈、威胁平台安全，或不当访问或传播受保护内容的账户，我们可能暂停或终止其使用权限。",
        ],
      },
      {
        title: "15. 条款变更",
        paragraphs: [
          "我们可能不时更新本使用条款。在更新后的条款生效后继续使用本服务，即表示您接受修订后的条款。",
        ],
      },
      {
        title: "16. 联系方式",
        paragraphs: [
          "如对本使用条款有任何疑问，请通过以下方式联系我们：",
        ],
      },
    ],

    contactEmail: "supports@acemassagehub.com",
  },

  es: {
    back: "← Volver al inicio",
    eyebrow: "LEGAL",
    title: "Términos de uso",
    effectiveDate: "Fecha de entrada en vigor: 5 de septiembre de 2026",
    translationNotice:
      "Esta traducción se proporciona únicamente para facilitar la lectura. En caso de discrepancia con la versión en inglés, prevalecerá la versión en inglés.",

    intro:
      "Bienvenido a ACE Massage Hub y Massage Exam Practice App. Al acceder o utilizar este sitio web, aplicación, plataforma de aprendizaje, herramientas de práctica, servicios de suscripción o funciones relacionadas, aceptas estos Términos de uso.",

    sections: [
      {
        title: "1. Propósito educativo",
        paragraphs: [
          "ACE Massage Hub proporciona materiales educativos, preguntas de práctica, herramientas de estudio, recursos de vocabulario, explicaciones generadas por IA y otras funciones de aprendizaje destinadas a apoyar la educación en terapia de masaje y la preparación para exámenes.",
          "Nuestros servicios tienen únicamente fines educativos. No garantizamos que el uso de la plataforma resulte en aprobar el MBLEx, obtener una licencia de terapia de masaje, renovar una licencia profesional o cumplir con los requisitos de licencia de un estado en particular.",
        ],
      },
      {
        title: "2. Registro de cuenta",
        paragraphs: [
          "Algunas funciones requieren una cuenta. Eres responsable de proporcionar información precisa, proteger tus credenciales de acceso y mantener la seguridad de tu cuenta.",
          "No puedes compartir tu cuenta, permitir que usuarios no autorizados accedan a contenido de pago a través de ella ni crear varias cuentas para evitar límites de uso, requisitos de suscripción u otras restricciones de la plataforma.",
        ],
      },
      {
        title: "3. Acceso gratuito y Premium",
        paragraphs: [
          "Las cuentas gratuitas pueden tener acceso a un número limitado de preguntas de práctica y a determinadas funciones de la plataforma. Los suscriptores Premium pueden recibir acceso ampliado, incluido el banco completo de preguntas elegibles, Learning Center, Vocabulary, explicaciones ilimitadas con IA y otras funciones Premium disponibles periódicamente.",
        ],
      },
      {
        title: "4. Facturación de suscripciones",
        paragraphs: [
          "Las suscripciones Premium pueden ofrecerse de forma mensual o trimestral. El precio vigente se muestra antes de completar el pago.",
          "A menos que se cancele, una suscripción de pago se renovará automáticamente en el intervalo de facturación correspondiente utilizando el método de pago asociado con la cuenta.",
          "Puedes cancelar tu suscripción mediante las herramientas de administración de facturación disponibles. Si cancelas, el acceso Premium generalmente continuará hasta el final del período de facturación ya pagado, salvo que se indique lo contrario.",
        ],
      },
      {
        title: "5. Pruebas gratuitas",
        paragraphs: [
          "Los nuevos suscriptores elegibles pueden recibir una prueba Premium de tres días. La elegibilidad puede limitarse a una prueba por usuario, método de pago, cuenta, hogar u otros criterios razonables de prevención del fraude.",
          "Si la prueba requiere un método de pago y no se cancela antes de finalizar, la suscripción puede convertirse automáticamente en una suscripción de pago al precio del plan seleccionado.",
        ],
      },
      {
        title: "6. Reembolsos",
        paragraphs: [
          "Los pagos de suscripción generalmente no son reembolsables una vez cobrados, excepto cuando lo exija la ley o cuando ACE Massage Hub determine que corresponde realizar un reembolso.",
          "Si crees que se te ha cobrado incorrectamente, comunícate con nosotros en supports@acemassagehub.com.",
        ],
      },
      {
        title: "7. Explicaciones generadas por IA",
        paragraphs: [
          "Algunas explicaciones educativas pueden ser generadas o asistidas por inteligencia artificial. El contenido generado por IA puede contener errores, omisiones o información incompleta y no debe considerarse asesoramiento médico, legal, profesional o relacionado con licencias.",
          "Los estudiantes deben utilizar las explicaciones de IA como una ayuda de estudio junto con materiales educativos aprobados, orientación de instructores y recursos oficiales de las autoridades de licencias.",
        ],
      },
      {
        title: "8. Cursos de educación continua",
        paragraphs: [
          "En el futuro podrán añadirse cursos de educación continua a la plataforma.",
          "La aceptación de horas de educación continua varía según el estado, la junta de licencias, la profesión, el tipo de curso, la aprobación del proveedor y otros requisitos. Los usuarios son responsables de confirmar que un curso sea aceptado por la autoridad de licencias correspondiente antes de utilizarlo para renovar una licencia.",
        ],
      },
      {
        title: "9. Propiedad intelectual",
        paragraphs: [
          "El contenido de la plataforma, incluidas preguntas de práctica, explicaciones, materiales de cursos, gráficos, software, recursos de estudio y otros materiales educativos, pertenece a ACE Massage Hub o se utiliza bajo licencia y está protegido por las leyes de propiedad intelectual aplicables.",
          "Puedes utilizar el contenido para fines educativos personales y no comerciales. Sin autorización escrita, no puedes copiar, extraer, descargar masivamente, reproducir, revender, publicar, distribuir, crear bancos de preguntas competidores a partir del contenido ni explotarlo comercialmente de otra manera.",
        ],
      },
      {
        title: "10. Conductas prohibidas",
        paragraphs: [
          "Aceptas no hacer un uso indebido de la plataforma, intentar obtener acceso no autorizado, interferir con la seguridad, automatizar la extracción de contenido, eludir controles de suscripción o uso, realizar ingeniería inversa de sistemas protegidos ni utilizar el servicio para fines ilegales.",
        ],
      },
      {
        title: "11. Disponibilidad y cambios",
        paragraphs: [
          "A medida que evoluciona la plataforma, podemos actualizar, modificar, suspender, eliminar o reemplazar funciones, contenido, precios, bancos de preguntas, modelos de IA u otras partes del servicio.",
          "No garantizamos un acceso ininterrumpido o libre de errores al servicio.",
        ],
      },
      {
        title: "12. Exclusión de garantías",
        paragraphs: [
          'En la máxima medida permitida por la ley, el servicio se proporciona "tal cual" y "según disponibilidad". ACE Massage Hub no garantiza resultados de exámenes, resultados de licencias, resultados laborales, resultados educativos ni la exactitud absoluta de todo el contenido de la plataforma.',
        ],
      },
      {
        title: "13. Limitación de responsabilidad",
        paragraphs: [
          "En la máxima medida permitida por la ley, ACE Massage Hub no será responsable de daños indirectos, incidentales, especiales, consecuentes o punitivos derivados del uso o de la imposibilidad de utilizar el servicio.",
        ],
      },
      {
        title: "14. Terminación",
        paragraphs: [
          "Podemos suspender o cancelar cuentas que infrinjan estos Términos, hagan un uso indebido de la plataforma, participen en fraude, amenacen la seguridad de la plataforma o accedan o distribuyan indebidamente contenido protegido.",
        ],
      },
      {
        title: "15. Cambios en estos Términos",
        paragraphs: [
          "Podemos actualizar estos Términos periódicamente. El uso continuado del servicio después de que entren en vigor los Términos actualizados constituye la aceptación de los Términos revisados.",
        ],
      },
      {
        title: "16. Contacto",
        paragraphs: [
          "Las preguntas relacionadas con estos Términos pueden enviarse a:",
        ],
      },
    ],

    contactEmail: "supports@acemassagehub.com",
  },

  ru: {
    back: "← Вернуться на главную",
    eyebrow: "ПРАВОВАЯ ИНФОРМАЦИЯ",
    title: "Условия использования",
    effectiveDate: "Дата вступления в силу: 5 сентября 2026 г.",
    translationNotice:
      "Этот перевод предоставлен исключительно для удобства ознакомления. В случае расхождений с английской версией преимущественную силу имеет английская версия.",

    intro:
      "Добро пожаловать в ACE Massage Hub и Massage Exam Practice App. Получая доступ к этому веб-сайту, приложению, учебной платформе, инструментам для практики, услугам подписки или связанным функциям либо используя их, вы соглашаетесь с настоящими Условиями использования.",

    sections: [
      {
        title: "1. Образовательные цели",
        paragraphs: [
          "ACE Massage Hub предоставляет образовательные материалы, практические вопросы, учебные инструменты, словарные ресурсы, объяснения, созданные с помощью ИИ, и другие учебные функции для поддержки обучения массажной терапии и подготовки к экзаменам.",
          "Наши услуги предназначены исключительно для образовательных целей. Мы не гарантируем, что использование платформы приведет к успешной сдаче MBLEx, получению лицензии массажиста, продлению профессиональной лицензии или выполнению конкретных лицензионных требований какого-либо штата.",
        ],
      },
      {
        title: "2. Регистрация учетной записи",
        paragraphs: [
          "Для использования некоторых функций требуется учетная запись. Вы несете ответственность за предоставление точной информации, защиту своих учетных данных и обеспечение безопасности учетной записи.",
          "Запрещается передавать свою учетную запись другим лицам, предоставлять неавторизованным пользователям доступ к платному контенту через вашу учетную запись или создавать несколько учетных записей для обхода ограничений использования, требований подписки или других ограничений платформы.",
        ],
      },
      {
        title: "3. Бесплатный и Premium-доступ",
        paragraphs: [
          "Бесплатные учетные записи могут получать доступ к ограниченному количеству практических вопросов и отдельным функциям платформы. Подписчики Premium могут получать расширенный доступ, включая полный доступный банк вопросов, Learning Center, Vocabulary, неограниченные объяснения с помощью ИИ и другие Premium-функции, предоставляемые время от времени.",
        ],
      },
      {
        title: "4. Оплата подписки",
        paragraphs: [
          "Premium-подписки могут предлагаться с ежемесячной или ежеквартальной оплатой. Актуальная стоимость отображается перед оформлением платежа.",
          "Если подписка не отменена, платная подписка автоматически продлевается с соответствующим расчетным интервалом с использованием способа оплаты, связанного с вашей учетной записью.",
          "Вы можете отменить подписку с помощью доступных инструментов управления платежами. После отмены Premium-доступ обычно сохраняется до окончания уже оплаченного расчетного периода, если не указано иное.",
        ],
      },
      {
        title: "5. Бесплатные пробные периоды",
        paragraphs: [
          "Новым подписчикам, соответствующим требованиям, может быть предложен трехдневный пробный период Premium. Право на пробный период может быть ограничено одним использованием на пользователя, способ оплаты, учетную запись, домохозяйство или на основании других разумных критериев предотвращения мошенничества.",
          "Если для пробного периода требуется способ оплаты и подписка не отменена до его окончания, она может автоматически перейти в платную подписку по стоимости выбранного плана.",
        ],
      },
      {
        title: "6. Возврат средств",
        paragraphs: [
          "После списания платежи за подписку, как правило, не подлежат возврату, за исключением случаев, предусмотренных законом, или случаев, когда ACE Massage Hub считает возврат средств обоснованным.",
          "Если вы считаете, что с вас ошибочно списали средства, свяжитесь с нами по адресу supports@acemassagehub.com.",
        ],
      },
      {
        title: "7. Объяснения, созданные с помощью ИИ",
        paragraphs: [
          "Некоторые образовательные объяснения могут создаваться или дополняться искусственным интеллектом. Материалы, созданные ИИ, могут содержать ошибки, пропуски или неполную информацию и не должны рассматриваться как авторитетная медицинская, юридическая, лицензионная или профессиональная консультация.",
          "Студентам следует использовать объяснения ИИ в качестве вспомогательного учебного инструмента вместе с утвержденными образовательными материалами, рекомендациями преподавателей и официальными ресурсами лицензирующих органов.",
        ],
      },
      {
        title: "8. Курсы повышения квалификации",
        paragraphs: [
          "В будущем на платформу могут быть добавлены курсы повышения квалификации.",
          "Признание часов повышения квалификации зависит от штата, лицензирующего органа, профессии, типа курса, статуса поставщика и других требований. Пользователи обязаны самостоятельно убедиться, что соответствующий курс принимается применимым лицензирующим органом, прежде чем использовать его для продления лицензии.",
        ],
      },
      {
        title: "9. Интеллектуальная собственность",
        paragraphs: [
          "Содержимое платформы, включая практические вопросы, объяснения, материалы курсов, графику, программное обеспечение, учебные ресурсы и другие образовательные материалы, принадлежит ACE Massage Hub либо используется на основании лицензии и защищено применимым законодательством об интеллектуальной собственности.",
          "Вы можете использовать содержимое для личных некоммерческих образовательных целей. Без письменного разрешения запрещается копировать, автоматически извлекать, массово загружать, воспроизводить, перепродавать, публиковать, распространять, создавать конкурирующие банки вопросов на основе содержимого платформы или иным образом использовать его в коммерческих целях.",
        ],
      },
      {
        title: "10. Запрещенные действия",
        paragraphs: [
          "Вы соглашаетесь не злоупотреблять платформой, не пытаться получить несанкционированный доступ, не вмешиваться в работу систем безопасности, не автоматизировать извлечение контента, не обходить ограничения подписки или использования, не выполнять обратную разработку защищенных систем и не использовать сервис в незаконных целях.",
        ],
      },
      {
        title: "11. Доступность и изменения",
        paragraphs: [
          "По мере развития платформы мы можем обновлять, изменять, приостанавливать, удалять или заменять функции, содержимое, цены, банки вопросов, модели ИИ и другие части сервиса.",
          "Мы не гарантируем непрерывный или полностью безошибочный доступ к сервису.",
        ],
      },
      {
        title: "12. Отказ от гарантий",
        paragraphs: [
          'В максимально допустимой законом степени сервис предоставляется на условиях «как есть» и «по мере доступности». ACE Massage Hub не гарантирует результаты экзаменов, получение лицензий, результаты трудоустройства, образовательные результаты или абсолютную точность каждого элемента содержимого платформы.',
        ],
      },
      {
        title: "13. Ограничение ответственности",
        paragraphs: [
          "В максимально допустимой законом степени ACE Massage Hub не несет ответственности за косвенные, случайные, специальные, последующие или штрафные убытки, возникающие в результате использования или невозможности использования сервиса.",
        ],
      },
      {
        title: "14. Прекращение доступа",
        paragraphs: [
          "Мы можем приостановить или прекратить действие учетных записей, которые нарушают настоящие Условия, злоупотребляют платформой, участвуют в мошенничестве, создают угрозу безопасности платформы либо неправомерно получают доступ к защищенному контенту или распространяют его.",
        ],
      },
      {
        title: "15. Изменения настоящих Условий",
        paragraphs: [
          "Мы можем периодически обновлять настоящие Условия. Продолжение использования сервиса после вступления обновленных Условий в силу означает принятие пересмотренных Условий.",
        ],
      },
      {
        title: "16. Контакты",
        paragraphs: [
          "Вопросы, касающиеся настоящих Условий, можно направлять по адресу:",
        ],
      },
    ],

    contactEmail: "supports@acemassagehub.com",
  },
};

export default termsTranslations;